import Vue from 'vue';
import SvgIcon from '../../store-customization-v2/components/SvgIcon.vue';

const init = () => {
    new Vue({
        el: '.payt-cotainer-svg-icons-mobile',
        components: { SvgIcon },
        data() {
            return {
                currentSlide: 0,
                totalSliders: 0,
                btnScrollLeft: null,
                btnScrollRight: null,
            };
        },
        methods: {
            goPrev() {
                this.currentSlide--;
                this.updateMargin();
            },
            goNext() {
                this.currentSlide++;
                this.updateMargin();
            },
            updateMargin() {
                this.btnScrollLeft = this.currentSlide !== 0;
                this.btnScrollRight = this.currentSlide !== (this.totalSliders - 1);

                let newMargin = (this.currentSlide * document.body.clientWidth);
                document.querySelector('.carousel--container').style.marginLeft = `-${newMargin}px`;
            },
        },
        mounted() {
            this.totalSliders = document.querySelectorAll('.wrapper-mobile').length;
            document.querySelector('.carousel--container').style.width = `calc(100vw * ${this.totalSliders})`;
            this.btnScrollLeft = false;
            this.btnScrollRight = true;
        },
    });
};

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            init();
            observer.disconnect();
        }
    }, { rootMargin: '200px' });
    const target = document.querySelector('.payt-cotainer-svg-icons-mobile');
    if (target) {
        observer.observe(target);
    } else {
        init();
    }
} else {
    init();
}
